// extracted by mini-css-extract-plugin
export default {"wrap":"ViewEndpointsDialog-wrap","screenMessage":"ViewEndpointsDialog-screenMessage"};